export class MapSettings {
    public MapCentreEasting: number;
    public MapCentreNorthing: number;
    public MinZoom: number;
    public MaxZoom: number;
    public MapZoom: number;
    public ExtentMinX: number;
    public ExtentMinY: number;
    public ExtentMaxX: number;
    public ExtentMaxY: number;
    public BingApiKey: string;
    public EsdmOsmApiKey: string;
    public GazetteerApiKey: string;
    public BaseMaps: BaseMap[];
    public OtherMapWMSLayers: Layer[];

    public GetExtents(): [number, number, number, number] {
        return [this.ExtentMinX, this.ExtentMinY, this.ExtentMaxX, this.ExtentMaxY];
    }

    public GetCentre(): [number, number] {
        return [this.MapCentreEasting, this.MapCentreNorthing];
    }
}

export class BaseMap {
    public Order: number;
    public BaseMapType: string;
}

export class Layer {    
    public WMSURL: string;
    public LayerName: string;
    public WMSServerLayerNamesCSV: string;
    public HelpLinkURL: string;
}